module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ne-82c3626f7a2a329d1397e710d3076ae2.svg";